import { render, staticRenderFns } from "./HelpDeskTechnicianRequestEdit.vue?vue&type=template&id=4854a988&"
import script from "./HelpDeskTechnicianRequestEdit.vue?vue&type=script&lang=js&"
export * from "./HelpDeskTechnicianRequestEdit.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskTechnicianRequestEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports